import type { ComponentType } from 'react';

import { DecisionMakerIcon, GroupIcon, HeartIcon, NewspaperIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type WhoUsesCardType = Readonly<{
	Icon: ComponentType<{ size?: number }>;
	title: TranslationKey;
	description: TranslationKey;
}>;

export const WHO_USES_CARDS: ReadonlyArray<WhoUsesCardType & Readonly<{ id: string }>> = [
	{
		id: 'starters',
		Icon: GroupIcon,
		title: translationKey('corgi.impact_page.who_uses.starters.title'),
		description: translationKey('corgi.impact_page.who_uses.starters.description'),
	},
	{
		id: 'decision_makers',
		Icon: DecisionMakerIcon,
		title: translationKey('corgi.impact_page.who_uses.decision_makers.title'),
		description: translationKey('corgi.impact_page.who_uses.decision_makers.description'),
	},
	{
		id: 'organizations',
		Icon: HeartIcon,
		title: translationKey('corgi.impact_page.who_uses.organizations.title'),
		description: translationKey('corgi.impact_page.who_uses.organizations.description'),
	},
	{
		id: 'media',
		Icon: NewspaperIcon,
		title: translationKey('corgi.impact_page.who_uses.media.title'),
		description: translationKey('corgi.impact_page.who_uses.media.description'),
	},
];
